import React, { useEffect, useState } from "react"
import { useInView } from "react-intersection-observer"
import "intersection-observer"

import PuzzleCard from "./PuzzleCard"

const PuzzleCardList = ({ puzzles }) => {
  const [endOfList, endOfListInView] = useInView({ threshold: 0 })
  const [visiblePuzzles, setVisiblePuzzles] = useState([])
  const [canLoadMore, setCanLoadMore] = useState(true)

  useEffect(() => {
    if (visiblePuzzles.length && puzzles.length) {
      setCanLoadMore(visiblePuzzles.length < puzzles.length)
    }

    if (endOfListInView && canLoadMore) {
      setVisiblePuzzles((vp) => puzzles.slice(0, vp.length + 1))
    }
  }, [endOfListInView, puzzles, visiblePuzzles, canLoadMore])

  return (
    <div className="section">
      <div className="columns is-mobile is-multiline is-centered">
        {visiblePuzzles.map((p) => {
          return (
            <div key={p.puzzleId} className="column is-half-mobile is-one-third-tablet is-one-quarter-desktop is-one-fifth-widescreen">
              <PuzzleCard key={p.puzzeId} puzzle={p} />
            </div>
          )
        })}
      </div>
      <div ref={endOfList}></div>
    </div>
  )
}

export default PuzzleCardList
